export default __webpack_public_path__ + "static/media/documentPlaceHolder.aa202c1a.jpg";